import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { WarehouseDamageService } from "./service/warehouse-damage.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
addMore(Highcharts);
@Component({
  selector: "widget-warehouse-damage",
  templateUrl: "./widget-warehouse-damage.component.html",
  styleUrls: ["./widget-warehouse-damage.component.scss"]
})
export class WidgetWarehouseDamageComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  @Input() FILTERS;
  @Input() OPTIONS;
  highcharts: typeof Highcharts = Highcharts;
  chartOptions;

  constructor(
    private translateService: TranslateService,
    private dataService: WarehouseDamageService
  ) { }

  ngAfterViewInit() {
    this.getData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
      JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
      this.getData();
    }
  }

  ngOnInit() {
    this.translateService.get("WAREHOUSE.DAMAGE")
      .pipe(takeUntil(this.unsubscribe)).subscribe(text => {
        this.OPTIONS.title = this.OPTIONS.title || text;
      });
  }

  getData() {
    const options = {
      url: this.OPTIONS && this.OPTIONS.url ? this.OPTIONS.url : "",
      params: this.FILTERS
    };
    this.dataService.fetchData(options)
      .pipe(takeUntil(this.unsubscribe)).subscribe(chartData => {
        if (chartData.data && chartData.data.length) {
          this.chartOptions = this.dataService.createChart(
            chartData.data,
            this.OPTIONS
          );
        }
      });
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
